import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

import BaseIcon from '../IconV1'

export const Button = styled.div`
  width: 1.75rem;
  height: 1.75rem;
  background-color: ${color.WHITE};
  border-radius: 100%;
  box-shadow: 0 0.1875rem 0.5rem 0 rgba(0, 0, 0, 0.15),
    0 0.0625rem 0.0625rem 0 rgba(0, 0, 0, 0.16),
    0 0.1875rem 0.0625rem 0 rgba(0, 0, 0, 0.1);
  transition: left 0.2s;
  position: relative;
  top: 0.0625rem;

  left: ${p => (p.checked ? '1.3125rem' : '0.0625rem')};
  color: ${p => (p.checked ? color.AQUAMARINE : color.SILVER)};

  &:after {
    box-sizing: content-box;
    position: absolute;
    width: 1.75rem;
    height: 1.75rem;
    content: '';
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%) scale(0.75);
    border-radius: 100%;
    border: 0.625rem solid ${p => (p.checked ? color.AQUAMARINE : color.GREY)};
    transition: all 0.1s;
    opacity: 0;
  }
`

export const InputSwitch = styled.label`
  height: 1.875rem;
  width: 3.125rem;
  background: red;
  border-radius: 1.25rem;
  background: #aaa;
  display: block;
  cursor: pointer;
  transition: background 0.2s;
  background: ${p => (p.checked ? color.AQUAMARINE : color.SILVER)};

  &:hover {
    background: ${p => (p.checked ? color.AQUAMARINE : color.GREY)};

    ${Button} {
      color: ${p => (p.checked ? color.AQUAMARINE : color.GREY)};
    }
  }

  &:focus,
  &:active {
    ${Button}:after {
      ${p =>
        !p.disabled &&
        `transform: translateX(-50%) translateY(-50%) scale(1);
      opacity: 0.75;`}
    }
  }

  &[disabled] {
    background: ${color.GALLERY};
    cursor: not-allowed;
  }
`

export const Icon = styled(BaseIcon)`
  position: absolute;
  font-size: 0.875rem;
  top: 0.46875rem;
  left: 0.4375rem;
  transition: all 0.2s;
  transform: ${p => (p.checked ? 'scale(1)' : 'scale(0)')};
  transform-origin: 50% 50%;
  ${p => p.disabled && `color: ${color.STONE}`};
`

export const Input = styled.input`
  display: none;
`
